// import React, { useEffect, useState, useContext } from 'react';
// import { AuthContext } from '../../context/AuthContext';
// import { useParams, useNavigate } from 'react-router-dom';
// import Navbar from '../Navbar';
// import axios from 'axios';
// // import React, { useEffect, useState } from "react";
// // import { useParams, useNavigate } from "react-router-dom";
// // import Navbar from "../Navbar";
// // import axios from "axios";
// import Env from "../../runtimeEnv";

// const roomBaseUrls = {
//   beach: "https://plutonichealth.co/beach",
//   mountain: "https://plutonichealth.co/forest",
//   park: "https://plutonichealth.co/park",
//   campsite: "https://plutonichealth.co/campsite",
//   "park-therapy": "https://plutonichealth.co/park",
//   "beach-therapy": "https://plutonichealth.co/beach",
//   "forest-therapy": "https://plutonichealth.co/forest",
//   "campsite-therapy": "https://plutonichealth.co/campsite",
//   // "npcgpttherapist888": "https://plutonichealth.co/npcgpttherapist888",
// };

// function UnityRoom() {
//   const navigate = useNavigate();
//   const { roomType } = useParams();
//   const [roomUrl, setRoomUrl] = useState('');
//   const [isValidSession, setIsValidSession] = useState(false);
//   const {
//     currentNickname,
//     setCurrentNickname,
//     handleLogout,
//     setCurrentFormType,
//   } = useContext(AuthContext);

//   useEffect(() => {
//     const savedRoomId = sessionStorage.getItem("meetingID");
//     const savedUserId = sessionStorage.getItem("userId");

//     console.log("[UnityRoom] roomType:", roomType);
//     console.log("[UnityRoom] roomBaseUrls[roomType]:", roomBaseUrls[roomType]);

//     if (savedRoomId && savedUserId && roomType && roomBaseUrls[roomType]) {
//       setRoomId(savedRoomId);
//       setUserId(savedUserId);
//       setRoomUrl(
//         `${roomBaseUrls[roomType]}?roomId=${savedRoomId}&userId=${savedUserId}`
//       );
//       setIsValidSession(true);
//     } else {
//       console.warn('[UnityRoom] Missing or invalid session data.');
//       setIsValidSession(false);
//       navigate("/therapy-rooms"); // Redirect if the session is invalid
//     }
//   }, [roomType, navigate]);

//   useEffect(() => {
//     const setupUnityCommunication = () => {
//       console.log("setting up unity iframe ");
//       const unityIframe = document.getElementById("unity-iframe");
//       if (!unityIframe) {
//         console.error("[UnityRoom] Unity iframe not found.");
//         return;
//       }

//       // console.log('[UnityRoom] Unity iframe found. Setting up communication...');

//       // *** Ensure handleUnityMessage is defined properly ***
//       const handleUnityMessage = async (event) => {
//         console.log(
//           "[UnityRoom] Message received from Unity:",
//           event.data,
//           "from origin:",
//           event.origin
//         );

//         const trustedOrigins = [
//           "https://plutonichealth.co",
//           "http://localhost:3000",
//         ];
//         if (!trustedOrigins.includes(event.origin)) {
//           console.warn("[UnityRoom] Untrusted origin:", event.origin);
//           return;
//         }

//         if (event.data?.type === "unityReady") {
//           console.log("[UnityRoom] Unity is ready to receive data!");
//           const gatewayUrls = {
//     userGatewayUrl: Env.REACT_APP_USER_URL,
//     meetingsGatewayUrl: Env.REACT_APP_MEETINGS_URL,
//     sessionsGatewayUrl: Env.REACT_APP_SESSIONS_URL,
//   };

//           const message = JSON.stringify({
//             userId,
//             roomId,
//             gatewayUrls,
//           });
//           // const message = JSON.stringify({ userId, roomId });
//           console.log(
//             "[UnityRoom] Sending serialized message to Unity:",
//             message
//           );

//           if (unityIframe.contentWindow) {
//             unityIframe.contentWindow.postMessage(
//               message,
//               "https://plutonichealth.co"
//             );
//           } else {
//             console.error(
//               "[UnityRoom] contentWindow is null. Cannot send message."
//             );
//           }
//         }

//         // *** Handle leaveSession event ***
//         else if (event.data?.type === "leaveSession") {
//           console.log(
//             "[UnityRoom] User is leaving the session. Setting online status to false."
//           );

//           if (userId && roomId) {
//             try {
//               await axios.post(`${process.env.REACT_APP_PYTHON_API_URL}/api/set-online-status/${userId}`, {
//                 meetingID: roomId,
//                 online: false,
//               });
//               console.log('[UnityRoom] Online status updated successfully.');
//             } catch (error) {
//               console.error('[UnityRoom] Failed to update online status:', error);
//             }
//           }

//           navigate('/therapy-rooms');
//         }
//       };

//       window.addEventListener('message', handleUnityMessage);
//       return () => window.removeEventListener('message', handleUnityMessage);
//     };

//     if (isValidSession) {
//       const observer = new MutationObserver(() => {
//         if (document.getElementById("unity-iframe")) {
//           setupUnityCommunication();
//           observer.disconnect();
//         }
//       });

//       observer.observe(document.body, { childList: true, subtree: true });
//       return () => observer.disconnect();
//     }
//   }, [isValidSession, navigate]);

//   if (!isValidSession) {
//     return (
//       <div
//         style={{
//           width: "100%",
//           height: "100vh",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         <p>
//           Session data is missing or invalid. Please navigate back to the
//           Therapy Rooms.
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div style={{
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       width: '100vw',
//       height: '100vh',
//       margin: 0,
//       padding: 0,
//       overflow: 'hidden',
//     }}>
//       <Navbar
//         setCurrentNickname={setCurrentNickname}
//         currentNickname={currentNickname}
//         setCurrentFormType={setCurrentFormType}
//         handleLogout={handleLogout}
//         showButtons={true}
//         PlutonicuserID={sessionStorage.getItem('userId')}
//       />

//       <style>
//         {`
//           @media (min-width: 1400px) {
//             #unity-iframe {
//               position: fixed !important;
//               top: 96px !important;
//               left: 0 !important;
//               width: 100vw !important;
//               height: calc(100vh - 95px) !important;
//               transform: scale(1) !important;
//               transform-origin: center center !important;
//             }
//           }
//         `}
//       </style>

//       {roomUrl ? (
//         <iframe
//           id="unity-iframe"
//           src={roomUrl}
//           style={{
//             position: 'absolute',
//             top: '80px',
//             left: '0',
//             width: '100vw',
//             height: 'calc(100vh - 80px)',
//             border: 'none',
//             display: 'block',
//             overflow: 'hidden',
//           }}
//           title="Unity WebGL Build"
//           allow="fullscreen; camera; microphone; display-capture"
//           onLoad={() => {
//             console.log('[UnityRoom] Iframe loaded. Ready to send message.');
//             const unityIframe = document.getElementById('unity-iframe');
//             if (unityIframe && unityIframe.contentWindow) {
//               const message = JSON.stringify({
//                 userId: sessionStorage.getItem('userId'),
//                 roomId: sessionStorage.getItem('meetingID'),
//               });
//               unityIframe.contentWindow.postMessage(message, 'https://plutonichealth.co');
//             }
//           }}
//         />
//       ) : (
//         <p>Loading Unity Room...</p>
//       )}
//     </div>
//   );
// }

// export default UnityRoom;

import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import axios from "axios";
import Env from "../../runtimeEnv";

const currentDomain = window.location.hostname;

const isLocalhost =
  currentDomain === "localhost" || currentDomain === "127.0.0.1";
const targetDomain = isLocalhost
  ? "featureenv.plutonichealth.co"
  : currentDomain;

const roomBaseUrls = {
  beach: `https://${targetDomain}/beach`,
  mountain: `https://${targetDomain}/forest`,
  park: `https://${targetDomain}/park`,
  campsite: `https://${targetDomain}/campsite`,
  "park-therapy": `https://${targetDomain}/park`,
  "beach-therapy": `https://${targetDomain}/beach`,
  "forest-therapy": `https://${targetDomain}/forest`,
  "campsite-therapy": `https://${targetDomain}/campsite`,
  "beach-ai-companion":
    "https://featureenv.plutonichealth.co/devenv-ai-plutonictherapy/beach-ai-dev/index.html",
  "beach-ai-dev":
    "https://featureenv.plutonichealth.co/devenv-ai-plutonictherapy/beach-ai-dev/index.html",
};

function UnityRoom() {
  const navigate = useNavigate();
  const { roomType } = useParams();
  const [roomUrl, setRoomUrl] = useState("");
  const [isValidSession, setIsValidSession] = useState(false);
  const {
    currentNickname,
    setCurrentNickname,
    handleLogout,
    setCurrentFormType,
  } = useContext(AuthContext);

  useEffect(() => {
    const savedRoomId = sessionStorage.getItem("meetingID");
    const savedUserId = sessionStorage.getItem("userId");

    console.log("[UnityRoom] roomType:", roomType);
    console.log("[UnityRoom] roomBaseUrls[roomType]:", roomBaseUrls[roomType]);

    if (savedRoomId && savedUserId && roomType && roomBaseUrls[roomType]) {
      setRoomUrl(
        `${roomBaseUrls[roomType]}?roomId=${savedRoomId}&userId=${savedUserId}`
      );
      setIsValidSession(true);
    } else {
      console.warn("[UnityRoom] Missing or invalid session data.");
      setIsValidSession(false);
      navigate("/therapy-rooms");
    }
  }, [roomType, navigate]);

  // useEffect(() => {
  //   const setupUnityCommunication = () => {
  //     const unityIframe = document.getElementById("unity-iframe");
  //     if (!unityIframe) return;

  //     const handleUnityMessage = async (event) => {
  //       console.log(
  //         "[UnityRoom] Message received from Unity:",
  //         event.data,
  //         "origin:",
  //         event.origin
  //       );

  //       const trustedOrigins = [
  //         "https://plutonichealth.co",
  //         "http://localhost:3000",
  //         "https://devenv-plutonictherapy.s3.us-east-1.amazonaws.com",
  //       ];
  //       if (!trustedOrigins.includes(event.origin)) {
  //         console.warn("[UnityRoom] Untrusted origin:", event.origin);
  //         return;
  //       }

  //       if (event.data?.type === "unityReady") {
  //         console.log("[UnityRoom] Unity is ready to receive data!");
  //         const gatewayUrls = {
  //           userGatewayUrl: Env.REACT_APP_USER_URL,
  //           meetingsGatewayUrl: Env.REACT_APP_MEETINGS_URL,
  //           sessionsGatewayUrl: Env.REACT_APP_SESSIONS_URL,
  //         };

  //         const message = JSON.stringify({
  //           userId: sessionStorage.getItem("userId"),
  //           roomId: sessionStorage.getItem("meetingID"),
  //           gatewayUrls,
  //         });
  //         // const message = JSON.stringify({ userId, roomId });
  //         console.log(
  //           "[UnityRoom] Sending serialized message to Unity:",
  //           message
  //         );

  //         if (unityIframe.contentWindow) {
  //           setTimeout(() => {
  //             console.log(
  //               "[UnityRoom] Sending delayed message to Unity:",
  //               message
  //             );
  //             unityIframe.contentWindow.postMessage(
  //               message,
  //               "https://plutonichealth.co"
  //             );
  //           }, 300);
  //         } else {
  //           console.error(
  //             "[UnityRoom] contentWindow is null. Cannot send message."
  //           );
  //         }
  //       } else if (event.data?.type === "leaveSession") {
  //         console.log("[UnityRoom] User leaving session. Updating status...");
  //         const userId = sessionStorage.getItem("userId");
  //         const roomId = sessionStorage.getItem("meetingID");

  //         if (userId && roomId) {
  //           try {
  //             await axios.post(
  //               `${Env.REACT_APP_PYTHON_API_URL}/api/set-online-status/${userId}`,
  //               {
  //                 meetingID: roomId,
  //                 online: false,
  //               }
  //             );
  //             console.log("[UnityRoom] Online status updated successfully.");
  //           } catch (error) {
  //             console.error(
  //               "[UnityRoom] Failed to update online status:",
  //               error
  //             );
  //           }
  //         }

  //         navigate("/therapy-rooms");
  //       }
  //     };

  //     window.addEventListener("message", handleUnityMessage);
  //     return () => window.removeEventListener("message", handleUnityMessage);
  //   };

  //   if (isValidSession) {
  //     const observer = new MutationObserver(() => {
  //       if (document.getElementById("unity-iframe")) {
  //         setupUnityCommunication();
  //         observer.disconnect();
  //       }
  //     });

  //     observer.observe(document.body, { childList: true, subtree: true });
  //     return () => observer.disconnect();
  //   }
  // }, [isValidSession, navigate]);

  useEffect(() => {
    const setupUnityCommunication = () => {
      const unityIframe = document.getElementById("unity-iframe");
      if (!unityIframe) return;

      const handleUnityMessage = async (event) => {
        console.log(
          "[UnityRoom] Message received from Unity:",
          event.data,
          "origin:",
          event.origin
        );

        const allowedOrigin = new URL(roomUrl).origin;
        const trustedOrigins = [allowedOrigin, window.location.origin];

        if (!trustedOrigins.includes(event.origin)) {
          console.warn("[UnityRoom] Untrusted origin:", event.origin);
          return;
        }

        if (event.data?.type === "unityReady") {
          console.log("[UnityRoom] Unity is ready to receive data!");
          const gatewayUrls = {
            userGatewayUrl: Env.REACT_APP_USER_URL,
            meetingsGatewayUrl: Env.REACT_APP_MEETINGS_URL,
            sessionsGatewayUrl: Env.REACT_APP_SESSIONS_URL,
          };

          console.log("[UnityRoom] Gateway URLs being sent to Unity:");
          console.log("  userGatewayUrl:", gatewayUrls.userGatewayUrl);
          console.log("  meetingsGatewayUrl:", gatewayUrls.meetingsGatewayUrl);
          console.log("  sessionsGatewayUrl:", gatewayUrls.sessionsGatewayUrl);

          const message = JSON.stringify({
            userId: sessionStorage.getItem("userId"),
            roomId: sessionStorage.getItem("meetingID"),
            gatewayUrls,
          });

          console.log(
            "[UnityRoom] Sending serialized message to Unity:",
            message
          );

          if (unityIframe.contentWindow) {
            setTimeout(() => {
              console.log(
                "[UnityRoom] Sending delayed message to Unity:",
                message
              );
              unityIframe.contentWindow.postMessage(message, allowedOrigin);
            }, 300);
          } else {
            console.error(
              "[UnityRoom] contentWindow is null. Cannot send message."
            );
          }
        } else if (event.data?.type === "leaveSession") {
          console.log("[UnityRoom] User leaving session. Updating status...");
          const userId = sessionStorage.getItem("userId");
          const roomId = sessionStorage.getItem("meetingID");

          if (userId && roomId) {
            try {
              await axios.post(
                `${Env.REACT_APP_PYTHON_API_URL}/api/set-online-status/${userId}`,
                {
                  meetingID: roomId,
                  online: false,
                }
              );
              console.log("[UnityRoom] Online status updated successfully.");
            } catch (error) {
              console.error(
                "[UnityRoom] Failed to update online status:",
                error
              );
            }
          }

          navigate("/therapy-rooms");
        }
      };

      window.addEventListener("message", handleUnityMessage);
      return () => window.removeEventListener("message", handleUnityMessage);
    };

    if (isValidSession) {
      const observer = new MutationObserver(() => {
        if (document.getElementById("unity-iframe")) {
          setupUnityCommunication();
          observer.disconnect();
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
      return () => observer.disconnect();
    }
  }, [isValidSession, navigate, roomUrl]);

  if (!isValidSession) {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <p>
          Session data is missing or invalid. Please go back to Therapy Rooms.
        </p>
      </div>
    );
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        margin: 0,
        padding: 0,
        overflow: "hidden",
      }}
    >
      <Navbar
        setCurrentNickname={setCurrentNickname}
        currentNickname={currentNickname}
        setCurrentFormType={setCurrentFormType}
        handleLogout={handleLogout}
        showButtons={true}
        PlutonicuserID={sessionStorage.getItem("userId")}
      />

      <style>
        {`
          @media (min-width: 1400px) {
            #unity-iframe {
              position: fixed !important;
              top: 96px !important;
              left: 0 !important;
              width: 100vw !important;
              height: calc(100vh - 95px) !important;
              transform: scale(1) !important;
              transform-origin: center center !important;
            }
          }
        `}
      </style>

      {roomUrl ? (
        <iframe
          id="unity-iframe"
          src={roomUrl}
          style={{
            position: "absolute",
            top: "80px",
            left: "0",
            width: "100vw",
            height: "calc(100vh - 80px)",
            border: "none",
            display: "block",
            overflow: "hidden",
          }}
          title="Unity WebGL Build"
          allow="fullscreen; camera; microphone; display-capture"
          onLoad={() => {
            console.log("[UnityRoom] Iframe loaded. Ready to send message.");
            const unityIframe = document.getElementById("unity-iframe");
            if (unityIframe && unityIframe.contentWindow) {
              const message = JSON.stringify({
                userId: sessionStorage.getItem("userId"),
                roomId: sessionStorage.getItem("meetingID"),
              });
              unityIframe.contentWindow.postMessage(
                message,
                "https://plutonichealth.co"
              );
            }
          }}
        />
      ) : (
        <p>Loading Unity Room...</p>
      )}
    </div>
  );
}

export default UnityRoom;
